import styled from 'styled-components';

import { DataTable } from '../Datatable';

export const ReportDataTable = styled(DataTable)`
  /* Keep the report table at its full column width so it never collapses/clips
     its header (esp. empty reports). The FinancialReportBody wrapper provides
     the horizontal scroll, so on tablets/phones every column stays reachable. */
  min-width: max-content;

  .table .tbody .tr.no-results:last-of-type .td {
    border-bottom: 1px solid #ddd;
  }
`;
